<template>
<v-dialog scrollable v-model="isAddressEditDialog" content-class="medium">
    <v-card class="myprofile-popup">
        <v-card-title primary-title>
            {{memberProfileConstants.CONTACT_INFORMATION.EDIT_MY_ADDRESS}}
            <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="closeAddressDialog()"></i>
        </v-card-title>
        <v-card-text class="inner-scrollbar">
            <v-flex v-for="(address,index) in allAddresses" :key="`address-${index}`">
                <v-form :id="index" :ref="`addressForm-${address.order}`" v-model="address.valid">
                    <span class="required-label" mr-2>{{memberProfileConstants.REQUIRED}}</span>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.CONTACT_INFORMATION.ADDRESS_TYPE}} {{memberProfileConstants.ASTERISK}}</span>
                                <v-select attach v-model="address.type" :rules="memberProfileConstants.PROFESSIONAL_EXP.ADDRESS_ADDRESS_TYPE_RULE" color="ypo_blue" :items="address.addressTypes" item-text="addressType" :data-qe-id="'address_dropdown_'+index" required @change="onChangeAddressType($event,address,index)">
                                </v-select>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.COUNTRY}}</span>
                                <v-autocomplete attach color="ypo_blue" :data-qe-id="'countryFld_'+index" :items="Object.keys(countryAndStates).sort()" v-on:change="getStates($event, address,true)" v-model="address.country" :rules="memberProfileConstants.COUNTRY_REQUIRED" required></v-autocomplete>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.STREET}}</span>
                                <v-text-field color="ypo_blue" :data-qe-id="'streetFld_'+index" :rules="memberProfileConstants.PROFESSIONAL_EXP.STREET_REQUIRED" required v-model="address.street" :maxlength="memberProfileConstants.MAX_STREET_LENGTH"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.CITY}}</span>
                                <v-text-field color="ypo_blue" :data-qe-id="'cityFld_'+index" :rules="memberProfileConstants.PROFESSIONAL_EXP.CITY_REQUIRED" required v-model="address.city" :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 v-if="address.showStateField">
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.STATE}}</span>
                                <v-autocomplete attach color="ypo_blue" :data-qe-id="'stateFld_'+index" :items="address.states" item-text="stateProvince" v-model="address.state" :rules="memberProfileConstants.PROFESSIONAL_EXP.STATE_REQUIRED" :no-data-text="memberProfileConstants.CONTACT_INFORMATION.NO_STATES_AVAILABLE" required></v-autocomplete>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.POSTAL_CODE}}</span>
                                <v-text-field color="ypo_blue" :rules="memberProfileConstants.PROFESSIONAL_EXP.POSTAL_CODE_REQUIRED" :data-qe-id="'postalCodeFld_'+index" required @keypress="zipPostalCodeValidation" :maxlength="memberProfileConstants.MAX_ZIP_LENGTH" v-model="address.postalCode"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="check-list">
                        <v-flex xs12 class="label-text">
                            <v-checkbox color="ypo_blue" :label="memberProfileConstants.CONTACT_INFORMATION.MAKE_PRIMARY_ADDRESS" :data-qe-id="'isPrimary_check_'+index" @change="validateIsPrimaryField($event,index)" :disabled="isPrimaryReadOnly" v-model="address.isPrimary"></v-checkbox>
                        </v-flex>
                        <v-flex xs12 class="label-text">
                            <v-checkbox color="ypo_blue" :label="memberProfileConstants.CONTACT_INFORMATION.MAKE_VISIBLE_TO_OTHERS" :data-qe-id="'isYourthInternship_check_'+index" v-model="address.isPrivate"></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex class="btn-row" pl-0>
                            <v-btn class="primary_btn" id="addMore_address_btn_unittest" data-qe-id="addMoreEmergencyContactBtn" v-if="addressList.length <= 0" :disabled="!address.valid" @click="addAddressDialog()">
                                <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE}}
                            </v-btn>
                            <v-btn class="primary_btn" color="primary" :id="'delete_address_btn_unittest_'+index" :data-qe-id="'deleteEmergencyContactBtn'+index" v-if="address.isEdit" @click="deleteAddressInfo(address)">
                                <i class="fas fa-trash-alt mr-2"></i> {{appCommonConstants.DELETE}}
                            </v-btn>
                            <v-flex :data-qe-id="'saveSuccessLabel_'+index" class="save-to-profile" v-if="address.isSuccess">
                                <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-dialog v-model="deleteAddressDialog" lazy absolute content-class="post-actions">
                        <v-card>
                            <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                                <v-btn :data-qe-id="'deleteEmergencyContact_closeIcon'+index" icon @click="deleteAddressDialog=false">
                                    <v-icon size="20">close</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex pt-3 pb-3>{{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}</v-flex>
                            <v-flex text-xs-right>
                                <status-bar :action="saveAddressAction"></status-bar>
                                <v-btn flat @click="deleteAddressDialog = false" :data-qe-id="'deleteEmergencyContact_closeBtn'+index" class="primary_btn transparent">
                                    {{memberProfileConstants.CANCEL}}
                                </v-btn>
                                <v-btn dark @click="deleteAddress()" class="primary_btn" id="deleteConfirmation_address_btn_unittest" :data-qe-id="'deleteEmergencyContact_continueBtn'+index">
                                    {{memberProfileConstants.CONTINUE}}
                                </v-btn>
                            </v-flex>
                        </v-card>
                    </v-dialog>
                </v-form>
            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-flex text-xs-right pa-3>
                <status-bar v-if="!isDeleteInProgress" :action="saveAddressAction"></status-bar>
                <v-btn class="primary_btn transparent" data-qe-id="close_dialog_btn" @click="closeAddressDialog()">
                    {{appCommonConstants.CANCEL}}
                </v-btn>
                <v-btn class="primary_btn" data-qe-id="address_saveBtn" :disabled="!isAllAddressFormsValid" @click="saveAddressDetails()">
                    {{appCommonConstants.DONE}}
                </v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
import { appCommonConstants } from "../../appCommon.constants.js";
import { memberProfileConstants } from "../memberProfile.constants.js";
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import { storeGetters } from "../../../store/storeGetters.constant";
import { zipPostalCodeValidation } from "@/common/utils/utils.js";
import StatusBar from "../../StatusBar/StatusBar";
import Vue from 'vue';
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { gaDataLayerEvent } from "@/plugins/analytics";

export default {
    name: "AddressEditDialog",
    components: {
        StatusBar,
    },
    data: () => ({
        appCommonConstants,
        memberProfileConstants,
        zipPostalCodeValidation,
        allAddresses: [],
        deleteAddressDialog: false,
        isDeleteInProgress: false,
        isAllAddressFormsValid: false,
        isPrimaryReadOnly: false,
        selectedAddress: {},
        address: {
            isPrimary: false,
            isPrivate: false,
            type: null,
            country: null,
            street: "",
            city: null,
            state: null,
            postalCode: "",
            valid: false,
            showStateField: false,
        },
    }),
    props: {
        value: {
            type: Boolean,
        },
        memberId: {
            type: String,
            required: true,
        },
        addresses: {
            type: Array | Object,
            required: true,
        },
        addressList: {
            type: Array,
            required: true,
        },
    },
    created() {
        this.allAddresses = this.addresses;
    },
    mounted() {
        this.allAddresses.forEach((data) => {
            if (data.isEdit) {
                data.isPrivate = !data.isPrivate;
                if (data.country !== null) {
                    this.getStates(data.country, data);
                }
                if (this.addressList.length === 1 && (this.contactInformation.isAddress1Primary || this.contactInformation.isAddress2Primary)) {
                    this.isPrimaryReadOnly = true;
                } else {
                    this.isPrimaryReadOnly = false; 
                }
            } else {
                this.isPrimaryReadOnly = this.addressList.length === 0;
                data.isPrimary = this.addressList.length === 0;
            }
        });
    },
    methods: {
        ...mapActions({
            saveAddress: `memberProfile/${storeAction.saveAddress}`,
            getUserProfile: `memberProfile/${storeAction.getUserProfile}`,
        }),
        closeAddressDialog() {
            this.isAddressEditDialog = false;
        },
        onChangeAddressType(value, record, index) {
            const isAddMore = this.allAddresses.length === 2;
            if (isAddMore) {
                if (index === 0) {
                    this.allAddresses[1].addressTypes = this.addressTypes.filter(x => x.addressType !== value);
                } else {
                    this.allAddresses[0].addressTypes = this.addressTypes.filter(x => x.addressType !== value);
                }
            }
            if (value === 'Business' && isAddMore) {
                this.allAddresses.forEach((rec) => {
                    rec.isPrimary = false;
                });
                this.allAddresses[index].isPrimary = true;
            } else if (value !== 'Business' && isAddMore) {
                this.allAddresses.forEach((rec) => {
                    rec.isPrimary = true;
                });
                this.allAddresses[index].isPrimary = false;
            } else if ((this.addressList.length === 0) || (value === 'Business') || (this.addressList.length === 1 && this.isAddressEdit)) {
                record.isPrimary = true;
            } else {
                record.isPrimary = false;
            }
        },
        getStates(value, record, isOnChange) {
            if (record) {
                const states = this.countryAndStates[value];
                record.states = states ? states.filter(x => x.stateProvince !== null) : [];
                if (record.states.length > 0) {
                    record.showStateField = true;
                } else {
                    record.showStateField = false;
                }
                if (isOnChange) {
                    record.state = null;
                }
            }
        },
        validateIsPrimaryField(value, index) {
            if (value) {
                this.allAddresses.forEach((rec) => {
                    rec.isPrimary = false;
                });
                this.allAddresses[index].isPrimary = true;
            } else {
                this.allAddresses.forEach((rec) => {
                    rec.isPrimary = true;
                });
                this.allAddresses[index].isPrimary = false;
            }
        },
        addAddressDialog() {
            this.saveAddressDetails(true);
        },
        deleteAddressInfo(data) {
            this.selectedAddress = data;
            this.deleteAddressDialog = true;
        },
        deleteAddress() {
            const data = Vue.util.extend({}, this.contactInformation);
            if (this.selectedAddress.order === 1) {
                data.Address1Type = null;
                data.MailingCountry = null;
                data.MailingStreet = null;
                data.MailingCity = null;
                data.MailingState = null;
                data.MailingPostalCode = null;
                data.IsAddress1Primary = null;
                data.IsAddress1Private = null;
                if (this.contactInformation.isAddress1Primary) {
                    data.IsAddress2Primary = true;
                }
            } else if (this.selectedAddress.order === 2) {
                data.Address2Type = null;
                data.OtherCountry = null;
                data.OtherStreet = null;
                data.OtherCity = null;
                data.OtherState = null;
                data.OtherPostalCode = null;
                data.IsAddress2Primary = null;
                data.IsAddress2Private = null;
                if (this.contactInformation.isAddress2Primary) {
                    data.IsAddress1Primary = true;
                }
            }
            this.isDeleteInProgress = true;
            this.saveAddress(data).then(() => {
                setTimeout(() => {
                  if (this.memberId)
                    this.getUserProfile(this.memberId);
                }, 1000);
                this.isDeleteInProgress = false;
                this.deleteAddressDialog = false;
                if (this.allAddresses.length === 1) {
                    this.isAddressEditDialog = false;
                } else {
                    Vue.delete(this.allAddresses, 0);
                }
                this.allAddresses.forEach((form) => {
                    const [ref] = this.$refs[`addressForm-${form.order}`];
                    if (ref && typeof ref.resetValidation === 'function') {
                        ref.resetValidation();
                    }
                });
                gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Address - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
            });
        },
        saveAddressDetails(isAddMore) {
            const data = Vue.util.extend({}, this.contactInformation);
            this.allAddresses.forEach((rec) => {
                if (rec.order === 1) {
                    data.address1Type = rec.type;
                    data.mailingCountry = rec.country;
                    data.mailingStreet = rec.street;
                    data.mailingCity = rec.city;
                    data.mailingState = rec.state;
                    data.mailingPostalCode = rec.postalCode;
                    data.isAddress1Primary = rec.isPrimary;
                    data.isAddress1Private = !rec.isPrivate;
                    if (rec.isPrimary) {
                        data.isAddress2Primary = false;
                    } else {
                        data.isAddress2Primary = true;
                    }
                } else {
                    data.address2Type = rec.type;
                    data.otherCountry = rec.country;
                    data.otherStreet = rec.street;
                    data.otherCity = rec.city;
                    data.otherState = rec.state;
                    data.otherPostalCode = rec.postalCode;
                    data.isAddress2Primary = rec.isPrimary;
                    data.isAddress2Private = !rec.isPrivate;
                    if (rec.isPrimary) {
                        data.isAddress1Primary = false;
                    } else {
                        data.isAddress1Primary = true;
                    }
                }
            });
            this.saveAddress(data).then(() => {
                setTimeout(() => {
                  if (this.memberId)
                    this.getUserProfile(this.memberId);
                }, 1000);
                this.allAddresses[0].isEdit = true;
                this.allAddresses[0].isSuccess = true;
                if (isAddMore) {
                    const record = Vue.util.extend({}, this.address);
                    record.isEdit = false;
                    record.order = this.addressList.find(x => x.order === 1) ? 2 : 1;
                    record.addressTypes = Vue.util.extend([], this.addressTypes);
                    this.isPrimaryReadOnly = false;
                    if (this.addressList && this.addressList.length > 0) {
                        const type = record.order === 1 ? this.contactInformation.address2Type : this.contactInformation.address1Type;
                        record.addressTypes.splice(this.addressTypes.findIndex(x => x.addressType === type), 1);
                    }
                    this.allAddresses.push(record);
                    setTimeout(() => {
                        document.getElementById(1).scrollIntoView();
                    }, 100);
                    this.allAddresses.forEach((form) => {
                        const [ref] = this.$refs[`addressForm-${form.order}`];
                        if (ref && typeof ref.resetValidation === 'function') {
                            ref.resetValidation();
                        }
                    });
                } else {
                    this.isAddressEditDialog = false;
                }
                gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Address - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
            });
        },
    },
    computed: {
        ...mapGetters({
            addressTypes: `memberProfile/${storeGetters.addressTypes}`,
            countryAndStates: `memberProfile/${storeGetters.countryAndStates}`,
            contactInformation: `memberProfile/${storeGetters.contactInformation}`,
        }),
        ...mapState("actionState", ["actions"]),
        isAddressEditDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        saveAddressAction() {
            return this.actions[storeAction.saveAddress];
        },
        AllAddressFormsValid() {
            return this.allAddresses.map(x => x.valid);
        },
        isRedirectFromConnectPlus() {
          return this.$route && this.$route.query
              && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
        },
    },
    watch: {
        addresses(val) {
            this.allAddresses = val;
        },
        AllAddressFormsValid: {
            handler(newval, oldval) {
                if (newval !== oldval) {
                    this.isAllAddressFormsValid = this.AllAddressFormsValid.filter(x => x === false).length === 0;
                }
            },
            deep: true,
        },
    },
};
</script>
